import PropTypes from 'prop-types';
import React from 'react';

const EmailPostviewPropType = {
  content: PropTypes.string.isRequired,
  viewport: PropTypes.oneOf(['mobile', 'desktop']).isRequired,
};

export default EmailPostviewPropType;
